import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTags } from "./tagsApi";

const initialState = {
  tags: [],
  isLoding: false,
  isError: false,
  error: "",
};

export const fetchTags = createAsyncThunk(
  "tags/fetchTags",
  async () => {
    const tags = getTags();
    return tags;
  }
  // const res=await
);

const tagsSlice = createSlice({
  name: "tags",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTags.pending, (state) => {
        state.isError = false;
        state.isLoding = true;
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.isLoding = false;
        state.tags = action.payload;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.isLoding = false;
        state.tags = [];
        state.isError = true;
        state.error = action.error.message;
      });
  },
});

export default tagsSlice.reducer;
